module.exports = __webpack_public_path__ + "static/media/formal_shirt_canvas.45c3b6fe.svg";